import { GET_AGREEMENTS_BY_INSTITUTION } from './../constants';
import { handleActions } from "redux-actions"
import { decrypt } from '../functions/mobile';

export const agreementsSwitchServices  = handleActions(
  {
    [ GET_AGREEMENTS_BY_INSTITUTION ]: (state, action) => {
      return JSON.parse(decrypt(action.payload.responseData)).response
    }
  }, []
)